
document.addEventListener("DOMContentLoaded", function () {
  // 対象クラスをまとめて取得
  const targets = document.querySelectorAll(
    ".fade-in-up, .fade-in, .fade-in-center, .fade-in-right, .fade-in-left, .heading-line",
  );

  // 共通Observer
  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // クラスごとの表示用クラスを付与
          if (
            entry.target.classList.contains("fade-in") ||
            entry.target.classList.contains("fade-in-center")
          ) {
            entry.target.classList.add("visible");
          } else {
            entry.target.classList.add("is-visible");
          }

          // 一度表示したら監視解除
          obs.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
    },
  );

  // 監視開始
  targets.forEach((el) => observer.observe(el));
});
